'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbIgnoreForBreadcrumb = fbIgnoreForBreadcrumb;
function fbIgnoreForBreadcrumb() {
    'ngInject';

    return {
        restrict: 'A',
        link: {
            pre: function pre(scope) {
                // This is dirty, but for now the only way.
                scope.ncyBreadcrumbIgnore = true;
            }
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/fb-ignoreForBreadcrumb.js
// module id = 716
// module chunks = 0